export default "__VITE_ASSET__DH0R3kIN__"